import { render, staticRenderFns } from "./VariableList.vue?vue&type=template&id=1078bebe&scoped=true&"
import script from "./VariableList.vue?vue&type=script&lang=js&"
export * from "./VariableList.vue?vue&type=script&lang=js&"
import style0 from "./VariableList.vue?vue&type=style&index=0&id=1078bebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1078bebe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1078bebe')) {
      api.createRecord('1078bebe', component.options)
    } else {
      api.reload('1078bebe', component.options)
    }
    module.hot.accept("./VariableList.vue?vue&type=template&id=1078bebe&scoped=true&", function () {
      api.rerender('1078bebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/VariableList.vue"
export default component.exports